/** 客户管理路由 */
// import Layout from '@/wkcrmViews/layout/CrmLayout.vue';
// const layout = function(meta = {}) {
//   return {
//     path: '/crm',
//     // component: Layout,
//     meta: {
//       requiresAuth: true,
//       ...meta
//     }
//   };
// };
export default [
    // {
    //   ...layout({
    //     permissions: ['crm']
    //   }),
    //   children: [{
    //     name: 'CRMWorkbench',
    //     path: 'workbench', // 仪表盘
    //     component: () => import('@/wkcrmViews/crm/workbench.vue'),
    //     meta: {
    //       title: '仪表盘',
    //       icon: 'board'
    //     }
    //   }]
    // },
    // {
    //   ...layout({
    //     permissions: ['crm']
    //   }),
    //   hidden: true,
    //   children: [{
    //     name: 'CRMWebview',
    //     path: 'webview', // 外部链接页面
    //     component: () => import('@/wkcrmViews/crm/webview.vue'),
    //     meta: {
    //       title: '测试外链',
    //       icon: 'board'
    //     }
    //   }]
    // },
    // // {
    // //   ...layout({
    // //     permissions: ['crm'],
    // //     title: '待办事项',
    // //     icon: 'message'
    // //   }),
    // //   children: [{
    // //     path: 'message/subs/message', // 待办事项
    // //     component: () => import('@/wkcrmViews/crm/message.vue'),
    // //     hidden: true,
    // //     meta: {
    // //       title: '待办事项',
    // //       icon: 'message',
    // //       num: 0
    // //     }
    // //   }, {
    // //     path: 'message/subs/message?infoType=todayLeads',
    // //     meta: {
    // //       title: '今日需联系线索',
    // //       icon: 'leads-line',
    // //       num: 0,
    // //       infoType: 'todayLeads'
    // //     }
    // //   }, {
    // //     path: 'message/subs/message?infoType=todayCustomer',
    // //     meta: {
    // //       title: '今日需联系客户',
    // //       icon: 'customer-line',
    // //       num: 0,
    // //       infoType: 'todayCustomer'
    // //     }
    // //   }, {
    // //     path: 'message/subs/message?infoType=todayBusiness',
    // //     meta: {
    // //       title: '今日需联系商机',
    // //       icon: 'business-line',
    // //       num: 0,
    // //       infoType: 'todayBusiness'
    // //     }
    // //   }, {
    // //     path: 'message/subs/message?infoType=followLeads',
    // //     meta: {
    // //       title: '分配给我的线索',
    // //       icon: 'leads-line',
    // //       num: 0,
    // //       infoType: 'followLeads'
    // //     }
    // //   }, {
    // //     path: 'message/subs/message?infoType=followCustomer',
    // //     meta: {
    // //       title: '分配给我的客户',
    // //       icon: 'allow-me',
    // //       num: 0,
    // //       infoType: 'followCustomer'
    // //     }
    // //   }, {
    // //     path: 'message/subs/message?infoType=putInPoolRemind',
    // //     meta: {
    // //       title: '待进入公海的客户',
    // //       icon: 'seas',
    // //       num: 0,
    // //       infoType: 'putInPoolRemind'
    // //     }
    // //   }, {
    // //     path: 'message/subs/message?infoType=checkContract',
    // //     meta: {
    // //       title: '待审核合同',
    // //       icon: 'audit-wait',
    // //       num: 0,
    // //       infoType: 'checkContract'
    // //     }
    // //   }, {
    // //     path: 'message/subs/message?infoType=checkReceivables',
    // //     meta: {
    // //       title: '待审核回款',
    // //       icon: 'plan',
    // //       num: 0,
    // //       infoType: 'checkReceivables'
    // //     }
    // //   }, {
    // //     path: 'message/subs/message?infoType=remindReceivablesPlan',
    // //     meta: {
    // //       title: '待回款提醒',
    // //       icon: 'bell-line',
    // //       num: 0,
    // //       infoType: 'remindReceivablesPlan'
    // //     }
    // //   }, {
    // //     path: 'message/subs/message?infoType=endContract',
    // //     meta: {
    // //       title: '即将到期的合同',
    // //       icon: 'contract-wait',
    // //       num: 0,
    // //       infoType: 'endContract'
    // //     }
    // //   }, {
    // //     path: 'message/subs/message?infoType=returnVisitRemind',
    // //     meta: {
    // //       title: '待回访合同',
    // //       icon: 'visit-contract',
    // //       num: 0,
    // //       infoType: 'returnVisitRemind'
    // //     }
    // //   }, {
    // //     path: 'message/subs/message?infoType=checkInvoice',
    // //     meta: {
    // //       title: '待审核发票',
    // //       icon: 'invoice-wait',
    // //       num: 0,
    // //       infoType: 'checkInvoice'
    // //     }
    // //   }]
    // // },
    // {
    //   ...layout({
    //     permissions: ['crm', 'leads']
    //     // permissionList: [['crm', 'leads'], ['crm', 'applet']]
    //   }),
    //   children: [{
    //     path: 'leads', // 线索列表
    //     component: () => import('@/wkcrmViews/crm/leads.vue'),
    //     meta: {
    //       title: '线索',
    //       icon: 'leads'
    //     }
    //   }]
    // },
    // // {
    // //   ...layout({
    // //     permissions: ['crm', 'applet']
    // //   }),
    // //   children: [{
    // //     path: 'applet', // 名片列表
    // //     component: () => import('@/wkcrmViews/crm/applet.vue'),
    // //     meta: {
    // //       title: '名片线索',
    // //       icon: 'mp'
    // //     }
    // //   }]
    // // },
    {
        name: 'CRMWorkbench',
        path: '/crm/workbench',
        component: function () { return import('@/wkcrmViews/crm/workbench/index.vue'); },
        meta: {
            permissions: ['crm'],
            title: '仪表盘'
        }
    },
    {
        name: 'customer',
        path: '/crm/customer/subs/customer',
        hidden: true,
        component: function () { return import('@/wkcrmViews/crm/customer/index.vue'); },
        meta: {
            requiresAuth: true,
            permissions: ['crm', 'customer'],
            title: '客户管理'
        }
    },
    {
        name: 'customerSeas',
        path: '/crm/customer/subs/seas',
        hidden: true,
        component: function () { return import('@/wkcrmViews/crm/seas/index.vue'); },
        meta: {
            requiresAuth: true,
            permissions: ['crm', 'pool'],
            title: '客户公海'
        }
    },
    {
        name: 'customerDetail',
        path: '/crm/customer/detail',
        hidden: true,
        component: function () { return import('@/wkcrmViews/crm/customer/Detail.vue'); },
        meta: {
            requiresAuth: true,
            permissions: ['crm', 'customer'],
            title: '客户详情'
        }
    },
    {
        name: 'contacts',
        path: '/crm/customer/subs/contacts',
        hidden: true,
        component: function () { return import('@/wkcrmViews/crm/contacts/index.vue'); },
        meta: {
            requiresAuth: true,
            permissions: ['crm', 'contacts'],
            title: '联系人'
        }
    },
    {
        name: 'contactsDetail',
        path: '/crm/contacts/detail',
        hidden: true,
        component: function () { return import('@/wkcrmViews/crm/contacts/Detail.vue'); },
        meta: {
            requiresAuth: true,
            permissions: ['crm', 'contacts'],
            title: '联系人详情'
        }
    },
    {
        name: 'business',
        path: '/crm/business',
        hidden: true,
        component: function () { return import('@/wkcrmViews/crm/business/index.vue'); },
        meta: {
            requiresAuth: true,
            permissions: ['crm', 'business'],
            title: '商机'
        }
    },
    {
        name: 'leads',
        path: '/crm/leads',
        hidden: true,
        component: function () { return import('@/wkcrmViews/crm/leads/index.vue'); },
        meta: {
            requiresAuth: true,
            permissions: ['crm', 'business'],
            title: '线索'
        }
    },
    // {
    //   ...layout({
    //     // permissions: ['crm', 'customer']
    //     permissionList: [['crm', 'customer'], ['crm', 'pool'], ['crm', 'customer', 'nearbyCustomer']],
    //     title: '客户',
    //     icon: 'customer-line'
    //   }),
    //   children: [
    //   {
    //   path: 'customer/subs/customer', // 客户列表  subs  是子菜单
    //   component: () => import('@/wkcrmViews/crm/customer/index.vue'),
    //   permissions: ['crm', 'customer'],
    //   meta: {
    //     title: '客户',
    //     icon: 'customer-line'
    //   }
    // },
    //     {
    //       path: 'customer/subs/seas', // 公海
    //       component: () => import('@/wkcrmViews/crm/seas/index.vue'),
    //       permissions: ['crm', 'pool'],
    //       meta: {
    //         title: '公海',
    //         icon: 'seas'
    //       }
    //     }, {
    //       path: 'customer/subs/nearby', // 附近客户
    //       component: () => import('@/wkcrmViews/crm/nearby/index.vue'),
    //       permissions: ['crm', 'customer', 'nearbyCustomer'],
    //       meta: {
    //         title: '附近客户',
    //         icon: 'nearby'
    //       }
    //     }]
    // },
    // {
    //   ...layout({
    //     // permissions: ['crm', 'contacts']
    //     permissionList: [['crm', 'contacts'], ['crm', 'pool']],
    //     title: '联系人',
    //     icon: 'contacts-line'
    //   }),
    //   children: [{
    //     path: 'contacts/subs/contacts', // 联系人
    //     permissions: ['crm', 'contacts'],
    //     component: () => import('@/wkcrmViews/crm/contacts/index.vue'),
    //     meta: {
    //       title: '联系人',
    //       icon: 'contacts-line'
    //     }
    //   },
    //   {
    //     path: 'contacts/subs/seas', // 公海
    //     component: () => import('@/wkcrmViews/crm/seas.vue'),
    //     permissions: ['crm', 'contactsPool'],
    //     meta: {
    //       title: '公海',
    //       icon: 'seas'
    //     }
    //   }]
    // },
    // {
    //   ...layout({
    //     permissions: ['crm', 'business']
    //   }),
    //   children: [{
    //     path: 'business', // 商机列表
    //     component: () => import('@/wkcrmViews/crm/business.vue'),
    //     meta: {
    //       title: '商机',
    //       icon: 'business-line'
    //     }
    //   }]
    // },
    {
        name: 'crmContract',
        path: '/crm/contract',
        component: function () { return import('@/wkcrmViews/crm/contract/index.vue'); },
        meta: {
            title: '合同',
            permissions: ['crm', 'contract'],
            icon: 'contract-line'
        }
    },
    {
        name: 'crmReceivables',
        path: '/crm/receivables/subs/receivables',
        component: function () { return import('@/wkcrmViews/crm/receivables/index.vue'); },
        meta: {
            title: '回款',
            permissions: ['crm', 'receivables'],
            icon: 'receivables-line'
        }
    },
    {
        name: 'crmReceivablesPlan',
        path: '/crm/receivables/subs/plan',
        component: function () { return import('@/wkcrmViews/crm/receivablesPlan/index.vue'); },
        meta: {
            title: '回款计划',
            permissions: ['crm', 'receivablesPlan'],
            icon: 'plan'
        }
    },
    {
        name: 'crmInvoice',
        path: '/crm/invoice',
        component: function () { return import('@/wkcrmViews/crm/invoice/index.vue'); },
        meta: {
            title: '发票',
            icon: 'invoice-line'
        }
    },
    {
        name: 'print',
        path: '/print',
        component: function () { return import('@/wkcrmViews/crm/components/Print/index.vue'); },
        meta: {
            title: '打印',
            icon: 'print'
        }
    },
];
